
      if (!('anchorName' in document.documentElement.style)) {
        import('https://unpkg.com/@oddbird/css-anchor-positioning')
      }
    